<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-spacer />

    <v-btn
      v-if="hasRole('user', 'ROLE_POST_INTERNAL_USERS')"
      :to="{ name: 'User', params: { type: 'cadastrar' } }"
      color="accent"
      class="action-bar__btn"
      round
      depressed
    >
      {{ $t(`${namespace}.newUser`) }}
    </v-btn>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.UsersPage',
      breadcrumbItems: [
        { name: 'Users', title: this.$t('Views.UsersPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
